class ClipboardService {
  async write(data) {
    if (!navigator.clipboard) {
      throw 'Clipboard is not available'
    }

    const json = this.serialize(data)
    return navigator.clipboard.writeText(json)
  }
  async read() {
    if (!navigator.clipboard) {
      throw 'Clipboard is not available'
    }

    const json = await navigator.clipboard.readText()
    return this.deserialize(json)
  }
  serialize(data) {
    return JSON.stringify(data)
  }
  deserialize(json) {
    return JSON.parse(json)
  }
}

export { ClipboardService }
